module.exports = __webpack_public_path__ + "resources/img/img_skyhigh_security.cc9e37db286641a0992540c7b1bd4b2b.png";